<mat-toolbar 
  setColor
  [setColorRules]="[
    {
      color: 'primaryColour',
      style: 'background'
    }
  ]" 
  color="primary" 
  class="header selected">

  <div class="header__title">
    <app-navigation-menu></app-navigation-menu>

    <ng-container *ngIf="this.companyLogosService.activeCompanyLogo !== undefined; else noLogo">
      <img class="company-logo" [src]="this.companyLogosService.activeCompanyLogo" alt="logo"/>
    </ng-container>
    <ng-template #noLogo>
      <img class="hubbub-logo" [src]="this.environmentService.env.customLogoPath ? this.environmentService.env.customLogoPath : 'assets/HubbubHrLogo.svg'" alt="logo"/>
    </ng-template>

  </div>

  <app-site-search-bar></app-site-search-bar>

  <div class="header-toolbar">
    <!-- <app-notifications></app-notifications>
    <app-email></app-email> -->
    <app-translate></app-translate>
    <app-user [user]="user$" (signOut)="signOut()"></app-user>
  </div>

</mat-toolbar>
